// extracted by mini-css-extract-plugin
export default {"ctn":"parallaxLayout_ctn__b7g2-","reverse":"parallaxLayout_reverse__bxc3b"};